<template>
  <div class="app-container">
    <!--导航栏-->
    <van-nav-bar
      :title="$route.meta.title"
      left-arrow
    >
      <!--返回-->
      <van-icon
        slot="left"
        name="left"
        class-prefix="iconfont"
        @click="handleBack"
      />
      <!--创建-->
      <van-icon
        slot="right"
        name="add"
        class-prefix="iconfont"
        @click="handleStart"
      />
    </van-nav-bar>
    <!--提示-->
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
      如信息有误请与我中心联系，联系电话：{{ lxdh }}。
    </van-notice-bar>
    <!--申请标签页-->
    <van-tabs
      v-model="activeApplicationStatusIndex"
      swipeable
      animated
      @click="handleTabClick"
      @change="handleTabChange"
    >
      <van-tab
        v-for="(status,index) in applicationStatuses"
        :key="status.key"
        :title="status.text"
      >
        <!--申请列表-->
        <application-list
          :ref="'applicationList'+index"
          :page-size="pageSize"
          :status="status.key"
          :height="listHeight"
        />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { ApplicationStatus } from '@/utils/enums'
import { ApplicationList } from './components'
import { getSystemConfig } from '@/api/systemConfig.js'

export default {
  components: {
    ApplicationList
  },
  data() {
    return {
      activeApplicationStatusIndex: 0,
      pageSize: 3,
      tabChanging: false,
      lxdh: 'xxxx-xxxxxxxx' // 联系电话
    }
  },
  computed: {
    applicationStatuses: function() {
      return ApplicationStatus.getItems()
    },
    listHeight: function() {
      return document.documentElement.clientHeight - 89
    },
    activeApplicationList: function() {
      return this.$refs['applicationList' + this.activeApplicationStatusIndex][0]
    }
  },
  created() {
    // 设置默认选中的标签页
    const status = this.$route.params.status
    if (status) {
      this.activeApplicationStatusIndex = this.applicationStatuses.findIndex(s => s.key === status) || 0
    }
    // 获取系统配置
    this.loadSystemConfig()
  },
  methods: {
    // 处理标签点击事件
    handleTabClick(index, title) {
      if (!this.tabChanging) {
        if (this.activeApplicationList.scrollTop === 0) {
          this.activeApplicationList.refresh()
        } else {
          this.activeApplicationList.scrollToTop()
        }
      }
    },
    // 处理标签改变事件
    handleTabChange(index, title) {
      // 设置标签页状态为正在切换
      this.tabChanging = true
      this.$nextTick(() => {
        // 设置标签页状态为已切换
        this.tabChanging = false
      })
    },
    // 处理创建事件
    handleStart() {
      this.$router.push({ name: 'startApplicationInfo' })
    },
    // 处理返回事件
    handleBack() {
      this.$router.go(-1)
    },
    // 获取系统配置（区县名称、联系电话）
    loadSystemConfig() {
      getSystemConfig({
        'key': 'DJXT_LXDH'
      }).then(response => {
        this.lxdh = response.data.value
      })
    }
  }
}
</script>

<style lang="scss">
.van-tab {
  color: #333;
  font-size: 15px;
  font-weight: 700;
}
.van-tab.van-tab--active {
  color: #ff4444;
}
</style>

<style scoped lang="scss">
.app-container {
  height: 100vh;
  .van-nav-bar{
    .van-nav-bar__left{
      .iconfont {
        color: #969799;
        font-size: 24px;
        vertical-align:middle;
      }
    }
    .van-nav-bar__right{
      .iconfont {
        color: #969799;
        font-size: 24px;
        vertical-align:middle;
      }
    }
  }
  .van-tabs{
    margin-top: -1px;
  }
  .bottom{
    width:100%;
    height:4%;
    position: absolute;
    bottom:0;
    font-size:0.7em;
    p{
      margin: 0;
      padding: 2px;
      color: #969799;
    }
  }
}
</style>
